import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import NavSprite from "../../../assets/sprites/navigation/panel_middle.jpg";
import SidebarIcon from "../../../assets/sprites/navigation/sidebar-icon.webp";
import LineShort from "../../../assets/sprites/navigation/line-short.webp";
import LineWide from "../../../assets/sprites/navigation/line-wide.webp";
import { SCREENS } from "../components/responsive";

const LeftNavContainer = styled.div`
  @media screen and (min-width: ${SCREENS.md}) {
    background: url(${NavSprite});
    background-size: 100% auto;
    width: 100%;
    border-radius: 0 0 25px 25px;
    padding: 0.7rem 0 1rem 0;
  }
`;

const Lines = styled.div`
  text-align: center;
  position: relative;
  .first-line {
    margin-top: -10px;
  }
  .second-line {
    margin-top: -10px;
    margin-bottom: 8px;
  }
  .second-line-bot {
    margin-top: -10px;
  }
`;

const List = styled.ul`
  margin: 0;
  list-style: none;
`;

const Item = styled.li`
  margin-bottom: 0.6rem;

  a {
    position: relative;
    color: white;
    text-decoration: none;
    font-family: Martel;
    font-size: 1.3rem;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
      1px 1px 0 #000;
    ::before {
      background: url(${SidebarIcon}) no-repeat;
      position: absolute;
      display: block;
      content: "";
      height: 8px;
      left: -15px;
      width: 8px;
      top: 7px;
    }
    &:hover {
      ::before {
        background-position: -8px 0;
      }
    }
  }
`;

export default function LeftNav() {
  return (
    <LeftNavContainer>
      <Lines>
        <div className="first-line">
          <img src={LineShort} />
        </div>
        <div className="second-line">
          <img src={LineWide} />
        </div>
      </Lines>

      <List>
        <Item>
          <Link to="/">News</Link>
        </Item>
        <Item>
          <Link to="/login">Login</Link>
        </Item>
        <Item>
          <Link to="/register">Register</Link>
        </Item>
        <Item>
          <Link to="/download">Download</Link>
        </Item>
        <Item>
          <Link to="/search">Search</Link>
        </Item>
      </List>

      <Lines>
        <div className="first-line">
          <img src={LineWide} />
        </div>
        <div className="second-line-bot">
          <img src={LineShort} />
        </div>
      </Lines>
    </LeftNavContainer>
  );
}
